import { LocationQuery } from 'vue-router';
import { WorkerStatute } from './worker-statute.interface';
import { WorkerStatuteService } from './worker-statute.service';

const service = new WorkerStatuteService();

export interface WorkerStatuteState {
   workerStatutes: Array<WorkerStatute>;
   filteredWorkerStatutes: Array<WorkerStatute>;
}

const state: WorkerStatuteState = {
   workerStatutes: [],
   filteredWorkerStatutes: [],
};

const getters = {
   workerStatutes(state: any) {
      return state.workerStatutes;
   },
};

const mutations = {
   SET_WORKER_STATUTES(state: any, workerStatutes: any) {
      state.workerStatutes = workerStatutes;
   },
   SET_FILTERED_WORKER_STATUTES(state: any, workerStatutes: any) {
      state.filteredWorkerStatutes = workerStatutes;
   },
};

const actions = {
   async getWorkerStatutes(context: any, query?: LocationQuery) {
      return await service.getWorkerStatutes(query).then((response: any) => {
         context.commit('SET_WORKER_STATUTES', response);
         return response;
      });
   },
   async getFilteredWorkerStatutes(context: any, filters: LocationQuery) {
      const response = await service.getFilteredWorkerStatutes(filters);
      context.commit('SET_FILTERED_WORKER_STATUTES', response);
      return response;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
